import { Role } from '@/common/model/types';
import { AppRoutes } from '@/app/routes/app_routes';
import type { GuidedTour } from '../types';

export const inviteMembersTour: GuidedTour = {
  id: 'invite-members',
  roles: [Role.COACH, Role.CLUB_ADMIN, Role.SUPER_ADMIN],
  steps: [
    {
      id: 'invite-intro',
      titleKey: 'tours.invite_members.intro.title',
      descriptionKey: 'tours.invite_members.intro.description',
      targetSelector: '',
      placement: 'center',
      order: 0,
    },
    {
      id: 'invite-email',
      titleKey: 'coach.invite_button.title',
      descriptionKey: 'coach.invite_button.description',
      targetSelector: '[data-onboarding="membership-invite-button"]',
      placement: 'bottom',
      route: AppRoutes.membership.requests,
      order: 1,
    },
    {
      id: 'invite-link',
      titleKey: 'coach.generate_link.title',
      descriptionKey: 'coach.generate_link.description',
      targetSelector: '[data-onboarding="membership-generate-link-button"]',
      placement: 'bottom',
      route: AppRoutes.membership.requests,
      order: 2,
    },
    {
      id: 'invite-requests',
      titleKey: 'tours.invite_members.requests.title',
      descriptionKey: 'tours.invite_members.requests.description',
      targetSelector: '[data-onboarding="membership-tabs"]',
      placement: 'right',
      route: AppRoutes.membership.requests,
      order: 3,
    },
    {
      id: 'invite-roles',
      titleKey: 'tours.invite_members.roles.title',
      descriptionKey: 'tours.invite_members.roles.description',
      targetSelector: '',
      placement: 'center',
      order: 4,
    },
  ],
};
